import { Paragraph, Show, tokens } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { useContext } from 'react';
import { FiInfo } from 'react-icons/fi';
import { Dropdown } from '../Dropdown/Dropdown';
import { Tabs } from '../Tabs/Tabs';
import { DrawerEmployeesContext } from './DrawerEmployees.context';
import {
	FlexColumn,
	FlexRow,
	Footer,
	Header,
	Main,
} from './DrawerEmployees.styles';
import { DrawerEmployeesContextProps } from './DrawerEmployees.types';
import { Loading } from './components/Loading/Loading';

export const DrawerEmployees = (): JSX.Element => {
	const {
		isLoading,
		employeesList,
		tabs,
		active,
		setActive,
		handleSave,
		onClose,
		isSaving,
		isMultiple,
	} = useContext<DrawerEmployeesContextProps>(DrawerEmployeesContext);

	if (isLoading) return <Loading />;

	return (
		<>
			<Header>
				<FlexColumn>
					<Paragraph
						fontSize="16px"
						fontWeight="600"
						color={tokens.color_primary}
					>
						<Show when={isMultiple} fallback={'Colaborador seleccionado'}>
							Colaboradores seleccionados
						</Show>
					</Paragraph>
					<FlexRow>
						<FiInfo color={tokens.color_primary} />
						<Paragraph fontWeight="600">{employeesList.length}</Paragraph>
						<Paragraph>
							<Show when={isMultiple} fallback={'colaborador seleccionado'}>
								colaboradores seleccionados
							</Show>
						</Paragraph>
					</FlexRow>
				</FlexColumn>
				<FlexColumn>
					<Paragraph
						fontSize="14px"
						fontWeight="600"
						color={tokens.color_primary}
					>
						Lista
					</Paragraph>
					<Dropdown options={employeesList} />
				</FlexColumn>
			</Header>
			<Main>
				<Tabs
					activeTab={active}
					tabs={tabs}
					onChange={(tabId) => setActive(tabId)}
					position="all"
					contentPadding="30px 0"
					contentHeight="calc(100vh - 138px - 94px - 120px)"
					overflow="hidden visible"
				/>
			</Main>
			<Footer>
				<Button
					variant="ghost"
					onClick={() => onClose(false)}
					disabled={isSaving}
				>
					Salir
				</Button>
				<Button onClick={handleSave} loading={isSaving}>
					Guardar
				</Button>
			</Footer>
		</>
	);
};
